import { NgModule } from '@angular/core';

import { PristineHighlightComponent } from '@pristinebase/components/highlight/highlight.component';

@NgModule({
    declarations: [
        PristineHighlightComponent
    ],
    exports: [
        PristineHighlightComponent
    ],
})
export class PristineHighlightModule
{

}
